import { ToolboxItem } from "@/components/map-tool-box";
import { PercentIcon } from "lucide-react";
import { ParkingPaymentModeType } from "../payment-zone-area.type";
import { AddIcon, CurbAreaIcon, EditModeIcon, SettingsIcon, TicketIcon, ViewIcon } from "components/icons";

export const paymentToolboxIcons: ToolboxItem<ParkingPaymentModeType>[] = [
  {
    name: "Paiement du stationnement",
    groups: [
      {
        text: "View",
        mode: ParkingPaymentModeType.View,
        icon: <ViewIcon className="h-5 w-5" />,
      },

      {
        text: "Add Parking payment",
        mode: ParkingPaymentModeType.AddParkingPayment,
        icon: <AddIcon className="h-5 w-5" />,
      },
      {
        text: "Edit Parking payment",
        mode: ParkingPaymentModeType.EditParkingPayment,
        icon: <EditModeIcon className="h-5 w-5" />,
      },
    ],
  },
  {
    name: "Zone de paiement",
    groups: [
      {
        text: "Mode de création des zones de paiement",
        mode: ParkingPaymentModeType.ManagePaymentZoneArea,
        icon: <CurbAreaIcon className="h-5 w-5" />,
      },
      {
        text: "Ajouter une tarification",
        mode: ParkingPaymentModeType.AddParkingRate,
        icon: <TicketIcon className="h-5 w-5" />,
      },
    ],
  },
  {
    name: "Configuration de la ville",
    groups: [
      {
        text: "Configurer la ville",
        mode: ParkingPaymentModeType.CityConfig,
        icon: <SettingsIcon className="h-5 w-5" color="#ffffff" />,
      },
      {
        text: "Gérer les commissions",
        mode: ParkingPaymentModeType.ManageFeeConfigs,
        icon: <PercentIcon className="h-5 w-5" />,
      },
    ],
  },
];
